import React from "react";
import PropTypes from "prop-types";

import Button from "../custom-widgets/button";
import SuggestionItemText from "./suggestion-item-text";
import Icon from "../custom-widgets/icon";

/**
 * @typedef {Object} SuggestionData
 * @property {string} id - The unique identifier for the suggestion.
 * @property {string} text - The text to be displayed for the suggestion you don't need to remove " | WaFd Bank" string here.
 * @property {Object} data - Additional data associated with the suggestion, can be used for custom behavior.
 */

/**
 * SuggestionItem component.
 *
 * @param {Object} props - The component props
 * @param {SuggestionData} props.data - The suggestion object containing id, title, and data of the suggestion.
 * @param {string} props.query - The current search query
 * @param {function} props.onPopulate - Function to handle populate query button click, takes the data (SuggestionData) as argument.
 * @param {function} props.onClick - Function to handle the click to the suggestion button, takes the data (SuggestionData) as argument.
 *
 * @returns {JSX.Element} The rendered SuggestionItem component
 */
const SuggestionItem = ({
  data = {
    id: "",
    text: ""
  },
  query = "",
  onPopulate = ({ id, text, data }) => {},
  onClick = ({ id, text, data }) => {}
}) => {
  return (
    <div className="d-flex flex-row">
      <Button
        type="button"
        onClick={() => onPopulate(data)}
        icon={{
          name: "search",
          class: "fa-lg"
        }}
        class="ss-item-left-icon inner-focus-within"
        containerClass="w-auto"
      />
      <div className="d-flex w-100">
        <button className="btn ss-item-button inner-focus-within" onClick={() => onClick(data)}>
          <SuggestionItemText text={data.text} query={query} />
          <Icon name="arrow-right" class="fa-lg float-right ss-item-button-icon" />
        </button>
      </div>
    </div>
  );
};

export default SuggestionItem;

SuggestionItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    data: PropTypes.object
  }).isRequired,
  query: PropTypes.string.isRequired,
  onPopulateQueryButtonClick: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
}
